export const DEVICE_TYPE = {
  MOBILE_200: 'll02',
  CAR_CHARGER: 'vl501',
};
